import React from 'react';
import { TFinalTest } from '../../../../store/finalTest/types';
import { IconCry } from '../../../svgs/IconCry';

interface PropsType {
  isTest?: boolean;
  test: TFinalTest;
  type: 'success' | 'fail';
}
export const TextMessageWebinar: React.FC<PropsType> = ({ isTest, test, type }) => {
  if (type === 'success' && !isTest) {
    return <h2>Ви вже успішно здали тест</h2>;
  }
  if (type === 'success' && test.quantity > 1 && isTest) {
    return <h2>Вітаю! Ви пройшли тест успішно!</h2>;
  }
  if (type === 'success' && isTest) {
    return <h2>Вітаю! Ви здали тест з першого разу!</h2>;
  }
  if (type === 'fail' && test.quantity > 1) {
    return (
      <h2>
        <IconCry />
        Тест не здано. Прохідний бал скаладає «{test.minPoints}». Ви набрали «{test.points}» балів. Пройдіть тестування заново.
      </h2>
    );
  }
  if (type === 'fail') {
    return (
      <h2>
        <IconCry />
        Шкода, тест не здано. Ви набрали «{test.points}» балів. Прохідний бал скаладає «{test.minPoints}». Спробуйте ще раз.
      </h2>
    );
  }
  return null;
};
